<template>
    <div class="mx-auto bg-gray-600 flex flex-nowrap whitespace-nowrap px-4 sm:px-6 lg:px-8 h-10 space-x-8">
        <NavLink :href="route('reports')" :active="route().current('reports')">
            Список готовых
        </NavLink>
    </div>
</template>

<script>
import NavLink from "@/Components/NavLink";

export default {
    components: {
        NavLink,
    },
}
</script>
